import React, { useState, useEffect } from "react"
import { ReactComponent as BtnRound } from "../../svg/btnRRound.svg";
import { ReactComponent as PaginationRoundBtn } from "../../svg/pginationRound.svg";
import formstore from "../../store/form";
import { observer } from "mobx-react-lite";
import SelectInput from "../stateless/forms/SelectInput";
import form from "../../store/form";

const ContactForm = observer((props) => {

    return (
        <div className="contact-form">
            <div className="name"> {form.getMessage}
                <input type="text" placeholder="Имя" value={form.getLocalData.name} onChange={(e) => { form.setName(e.target.value) }} />
            </div>
            <div className="subject">
                <SelectInput placeholder="Тема сообщения" items={form.getLocalData.items}
                    selected={form.getLocalData.selected_item}
                    handleChange={(e) => { form.setItem(e.target.value) }} />
            </div>
            <div className="body">
                <textarea placeholder="Сообщение"
                    name="body" id="body" cols="30" rows="10" value={form.getLocalData.body} onChange={(e) => { form.setBody(e.target.value) }}></textarea>
            </div>
            <div className="navi">
                <button className="btn gradient-bottons" onClick={() => { form.sentForm() }}>отправить</button>
            </div>
        </div>
    );
})

export default ContactForm;